import { notice } from "JS/utils/notice";

const btnShareLink = document.querySelector('.button--share-link');
if (btnShareLink) {
    btnShareLink.addEventListener('click', (e) => {
        navigator.clipboard.writeText(btnShareLink.getAttribute('data-link'))
            .then(() => {
                notice('Ссылка скопирована в буфер обмена', 'info');
            })
            .catch(err => {
                notice('Что-то пошло не так, попробуйте еще раз', 'error');
            });
    })
}